import { render, staticRenderFns } from "./WorkflowImportModal.vue?vue&type=template&id=64b4b069&scoped=true"
import script from "./WorkflowImportModal.vue?vue&type=script&lang=js"
export * from "./WorkflowImportModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowImportModal.vue?vue&type=style&index=0&id=64b4b069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4b069",
  null
  
)

export default component.exports